export const MonitorIdHashDefault:string = "bVjp0gjl"; 
